import Vue from "vue";
const noConsole = process.env.VUE_APP_ENV === "production";

function printLog(fn, args) {
  if (noConsole) {
    return;
  }
  fn.call(this, ...Array.from(args));
}

export function log() {
  if (noConsole) {
    return;
  }
  printLog(console.log, arguments);
}
// export function table() {
//   printLog(console.table, arguments);
// }
// export function error() {
//   printLog(console.error, arguments);
// }
// export function info() {
//   printLog(console.info, arguments);
// }

// TODO: maybe add color
export function logWithPrefix(prefix) {
  return function () {
    if (noConsole) {
      return;
    }
    Array.prototype.unshift.call(arguments, prefix);
    printLog(console.log, arguments);
  };
}

Vue.prototype.$lg = log;
// Vue.prototype.$tb = table;
Vue.prototype.$logWithPrefix = logWithPrefix;
// Vue.prototype.$err = error;
// Vue.prototype.$info = info;
